import React, { useMemo, useCallback } from 'react';
import { useForm, FormProvider } from 'react-hook-form';

import { useLocation } from 'react-router-dom';

import { appGoogleLogin } from 'models/auth';
import { appLogin } from 'models/auth';

import LoginTemplate from 'src/components/templates/Login/Login.jsx';

const Login = () => {
    const methods = useForm();
    const { search, state } = useLocation();

    const handleGoogleCredentialResponse = response => {
        const jwt = response.credential;
        return appGoogleLogin(jwt);
    };
    const redirectUrl = useMemo(() => {
        const searchParams = new URLSearchParams(search);
        return searchParams.get('redirectUrl');
    }, [search]);

    const onSubmit = useCallback(
        ({ email, password, remember }) => {
            return appLogin(email, password, remember, redirectUrl);
        },
        [redirectUrl]
    );

    return (
        <FormProvider {...methods}>
            <LoginTemplate
                onSubmit={onSubmit}
                showSnackbar={state?.reset}
                googleCallback={handleGoogleCredentialResponse}
            />
        </FormProvider>
    );
};

export default Login;
